import { GetterTree } from "vuex";
import { RootState, TaxPricePeriodTranslationState } from "@/types/store/clientzone";
import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";

export const getters: GetterTree<TaxPricePeriodTranslationState, RootState> = {
  GET_TAX_PRICE_PERIOD_TRANSLATION: (state): TaxPricePeriodTranslationData => state.taxPricePeriodTranslation[0]
}
